import { api } from '../api'

export const fetchResults = (url, params, data) => {
    var results = api
        .post(url, {user_string: data}, {params: params})
        .then(res => {
                return res.data
            }
        )
        .catch((err) => {
            if (err.response) {
                console.log(err.response)
                return err.response.status
            } else if (err.request) {
                return 503
            } else {
                return 500
            }
        });

    return results
}

export const fetchTypes = () => {
    var result = api
        .get('/types')
        .then(res => {
            return res.data
        })

    return result
}
